import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@workboard/action-item';
import { EffortListProps } from '../../../types/sidePanel.types';
import * as SidePanelAction from '../../../actions/sidePanel.actions';
import { useOnClickOutside } from '../../../../hooks/useOnClickOutside';
import { IconStateWrapper } from './iconWrapper';

const EffortListComp = (props: EffortListProps) => {
  const { t } = useTranslation();
  const {
    aiId, tagId, columnId, srcVal, values
  } = props;

  const [ref] = useOnClickOutside(() => {
    if (typeof props.hideShowListPopup === 'function') {
      props.hideShowListPopup();
    }
  });

  const onEffortClick = (item: any) => {
    if (srcVal == 'act') {
      if (aiId) {
        props.hideShowListPopup();
        props.dispatch(SidePanelAction.boardAiEffortChange(aiId, item.value, columnId));
        $.post(
          `${wbConfig.baseUrl}/activity/updateEffort`,
          { effort: item.value, act_id: aiId, tagId }
        );
      }
    } else if (srcVal == 'automation') {
      props.saveTitleAndValue(
        'effortTitle',
        item.label,
        'effortVal',
        item.value
      );
    }
  }

  const automationClass = (srcVal == 'automation') ? 'automationAttrWidth' : '';
  if (srcVal == 'automation') {
    values.unshift({ value: '', label: t('None') });
  }

  return (
    <div ref={ref} className={`effortListDivOuterWrap ${automationClass}`}>
      <div className="attrLabel">{t('EFFORT')}</div>
      {values.map((item: any, index: number) => (
        <div
          key={`effort_${item.value}`}
          className="effortVal attrValFont clickable"
          data-value={item.value}
          onClick={() => onEffortClick(item)}
        >
          <IconStateWrapper isSourceFromAct={(srcVal == 'act')}>
            {
              item?.icons?.component
                ? <Icon name={item?.icons?.component} width="16" height="16" />
                : ''
            }
          </IconStateWrapper>
          <div className="displayInlineB">{item.label}</div>
        </div>
      ))}
    </div>
  );
}

export default EffortListComp;
